import Vue from 'vue';
import VueRouter from 'vue-router';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

import App from './App.vue';
import Main from './components/Main.vue';
import About from './components/About.vue';
import Stories from './components/Stories.vue';
import Action from './components/Action.vue';
import Contact from './components/Contact.vue';

Vue.config.productionTip = false;
Vue.use(VueRouter);

new Vue({
  router: new VueRouter({
    routes: [
      {
        path: '/',
        component: Main,
      },
      { path: '/about', component: About },
      { path: '/stories', component: Stories },
      { path: '/action', component: Action },
      { path: '/contact', component: Contact },
    ],
  }),
  render: (h) => h(App),
}).$mount('#app');
